import React from 'react';
import _ from 'lodash';
import PageDirectory from './pageDirectory';
import InternalUsers from './internalUsers';
import GISViewers from './gisViewers';
import IdentityIntegration from './identityIntegration';
import SAMLMapping from './samlMapping';
import GISFeatureLayers from './gisFeatureLayers';
import SharingEnquiries from './sharingEnquiries';
import { SCREEN_SIZE } from 'types';

const smallScreens = [SCREEN_SIZE.MD, SCREEN_SIZE.SM];

const Configuration: React.FC<Props> = ({
  user,
  screenSize,
  organisation,
  handleRoleMappingSubmit,
  handleEmailDomainSubmit,
  handleInvalidatePermalink,
  invalidatePermalinkError,
  invalidatingPermalink,
  isUpdatingConfiguration,
  updateOrgConfiguration,
  configurationUpdateType
}) => {
  const { uuid } = organisation || {};
  const isEnterpriseAdmin = user?.is_enterprise_admin;
  return (
    <div id="configuration" className="configuration">
      <div id="mainContent-config" className="settings-main-content-2">
        <div className="main-section-title spacing-padding extra-margin-top"></div>

        <div id="internalUsersSection">
          <InternalUsers
            organisation={organisation}
            handleEmailDomainSubmit={handleEmailDomainSubmit}
            configurationUpdateType={configurationUpdateType}
            isUpdatingConfiguration={isUpdatingConfiguration}
          />
        </div>

        <div className="divider"></div>

        <div id="gisViewersSection">
          <GISViewers
            organisation={organisation}
            updateOrgConfiguration={updateOrgConfiguration}
          />
        </div>

        <div className="divider"></div>

        <div id="gisFeatureLayersSection">
          <GISFeatureLayers />
        </div>

        <div className="divider"></div>

        <div id="sharingEnquiriesSection">
          <SharingEnquiries
            organisation={organisation}
            updateOrgConfiguration={updateOrgConfiguration}
            handleInvalidatePermalink={handleInvalidatePermalink}
            invalidatePermalinkError={invalidatePermalinkError}
            invalidatingPermalink={invalidatingPermalink}
          />
        </div>

        {(_.isNil(uuid) || isEnterpriseAdmin) && (
          <div>
            <div className="divider"></div>

            <div id="identityIntegrationSection">
              <IdentityIntegration user={user} />
            </div>
          </div>
        )}

        <div className="divider"></div>

        <div id="samlMappingSection">
          <SAMLMapping
            user={user}
            organisation={organisation}
            handleRoleMappingSubmit={handleRoleMappingSubmit}
            updateOrgConfiguration={updateOrgConfiguration}
            configurationUpdateType={configurationUpdateType}
            isUpdatingConfiguration={isUpdatingConfiguration}
          />
        </div>
      </div>
      {screenSize !== undefined && !smallScreens.includes(screenSize) && (
        <div id="rightContent" className="settings-right-content">
          <PageDirectory isEnterpriseAdmin={isEnterpriseAdmin} />
        </div>
      )}
    </div>
  );
};

interface Props {
  user: any;
  screenSize: any;
  organisation: any;
  handleRoleMappingSubmit: Function;
  updateOrgConfiguration: Function;
  handleEmailDomainSubmit: Function;
  handleInvalidatePermalink: Function;
  invalidatePermalinkError?: string;
  invalidatingPermalink?: boolean;
  isUpdatingConfiguration: boolean;
  configurationUpdateType: string;
}

export default React.memo(Configuration);
